// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useLedgerEnd: () => number | undefined = () => {
  const ledgerApi = useLedgerApiClient();
  const ledgerEndQuery = useQuery({
    queryKey: ['getLedgerEnd', ledgerApi],
    queryFn: () => ledgerApi.api().getV2StateLedgerEnd(),
  });
  return ledgerEndQuery.data?.offset;
};
